import { component } from 'picoapp'
import app from '@/app.js'

export default component((node, ctx) => {
  const overlay = node.querySelector('.js-overlay')
  const closeButton = node.querySelector('.js-close')

  const open = (menu) => {
    node.classList.add('is-active')
    setTimeout(() => {
      node.classList.add('is-visible')
      app.mount()
    }, 50)
  }

  const close = () => {
    node.classList.remove('is-visible')
    setTimeout(() => {
      node.classList.remove('is-active')
      app.hydrate({menuOpen: false})
    }, 400)
  }

  overlay.addEventListener('click', close)
  closeButton.addEventListener('click', close)

  ctx.on('menu:toggle', ({ menu, menuOpen }) => {
    menuOpen && open(menu)
  })
  ctx.on('cart:close', () => {
    ctx.getState().menuOpen ? close() : false
  })
})
